import writeExcelFile from 'write-excel-file/browser';

const headerCell = (value) => ({
  value,
  fontWeight: 'bold',
  color: '#FFFFFF',
  backgroundColor: '#6F67F6',
  align: 'center',
  verticalAlign: 'center',
  wrap: true,
});

const dataCell = (value) => ({
  value: value === null || value === undefined ? '' : value,
  verticalAlign: 'top',
  wrap: true,
});

export function excelSheet(sheet, columns, rows) {
  return {
    sheet: sheet.slice(0, 31),
    data: [
      columns.map((column) => headerCell(column.label)),
      ...rows.map((row) => row.map(dataCell)),
    ],
    columns: columns.map((column) => ({ width: column.width || 18 })),
    stickyRowsCount: 1,
  };
}

export async function downloadExcel(fileName, sheets) {
  await writeExcelFile(sheets).toFile(fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`);
}
